// client/loginAfterValidation.ts
import { AdornisRouter } from "@adornis/base/client/a-router";
var loginAfterValidation = () => {
  const session = AdornisRouter.get().queryParams.getOnce("session");
  if (!session)
    return;
  localStorage.setItem("sessionID", session);
  AdornisRouter.get().queryParams.delete("session");
};
export {
  loginAfterValidation
};
